import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import strings from 'strings';
import { FPCard, FPCardContent, FPCardHeader } from 'UI/components/atoms/FPCard';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { Endpoints } from 'UI/constants/endpoints';
import { isTruthyValue } from 'utils';

import { JobDescriptionContent } from '../components';
import { LoaderContainer, SelectFileLabel } from '../ResumeViewer/ResumeViewer.styled';

const COPIES = strings.inventory.jobOrders.profile.jobDescriptionTab;

export const JobDescriptionViewer = ({ jobOrderId }) => {
  const { Status, state } = useFetchWithStatusV2({
    endpoint: Endpoints.JobOrderParsedJobDescriptions.replace(':id', jobOrderId)
  });

  const results = state?.results;
  const [selectedFile, setSelectedFile] = useState(null);

  const activeJobDescriptionFile = selectedFile || results?.[0];
  const selectedJobDescription = activeJobDescriptionFile?.result?.data;

  const { job_title: jobTitle } = selectedJobDescription || {};

  const handleChange = event => {
    setSelectedFile(event.target.value);
  };

  return (
    <Status
      loading={
        <LoaderContainer>
          <CircularProgress />
        </LoaderContainer>
      }
      success={() => (
        <>
          {activeJobDescriptionFile && (
            <Box display="flex" alignItems="center" justifyContent="flex-end" mb={2}>
              <SelectFileLabel color="textSecondary" paragraph={false} variant="body2">
                {COPIES.selectFile}
              </SelectFileLabel>

              <Select value={activeJobDescriptionFile} onChange={handleChange}>
                {results?.map(resume => (
                  <MenuItem key={resume?.fileName} value={resume}>
                    <Typography variant="body2">{resume?.fileName}</Typography>
                  </MenuItem>
                ))}
              </Select>
            </Box>
          )}

          <FPCard>
            <FPCardHeader title={isTruthyValue(jobTitle) ? jobTitle : ''} />
            <FPCardContent>
              <JobDescriptionContent
                activeJobDescriptionFile={activeJobDescriptionFile}
                jobDescription={selectedJobDescription}
              />
            </FPCardContent>
          </FPCard>

          <Typography variant="body2" color="textSecondary" align="right" style={{ marginTop: 16 }}>
            {activeJobDescriptionFile?.parsingProvider ||
              activeJobDescriptionFile?.result?.response?.model ||
              COPIES.emptyModel}
          </Typography>
        </>
      )}
      error={error => (
        <Typography paragraph gutterBottom>
          {error}
        </Typography>
      )}
      empty={<EmptyPlaceholder subtitle={COPIES.emptyState.subtitle} />}
    />
  );
};
